import React, { useState, useEffect } from "react";
import { Modal, Input, Row, Col, message } from "antd";
import { isValidString } from "../../utils/utilities";
import "./verify-address-book.style.scss";

export const VerifyAddressBookModal = (props) => {
    const {
        visible,
        onCancel,
        onOk,
        addressRecord
    } = props;

    const [latitude, setLatitude] = useState("");
    const [longitude, setLongitude] = useState("");

    useEffect(() => {
        if (visible && addressRecord) {
            // Pre-fill with existing values if available
            setLatitude(addressRecord.latitude || "");
            setLongitude(addressRecord.longitude || "");
        }
    }, [visible, addressRecord]);

    const handleOk = () => {
        // Validate that both latitude and longitude are provided
        if (!isValidString(latitude) || !isValidString(longitude)) {
            message.error("Both Latitude and Longitude are mandatory!");
            return;
        }

        // Validate that they are valid numbers
        const latNum = parseFloat(latitude);
        const lngNum = parseFloat(longitude);

        if (isNaN(latNum) || isNaN(lngNum)) {
            message.error("Please enter valid numeric values for Latitude and Longitude!");
            return;
        }

        // Validate latitude range (-90 to 90)
        if (latNum < -90 || latNum > 90) {
            message.error("Latitude must be between -90 and 90!");
            return;
        }

        // Validate longitude range (-180 to 180)
        if (lngNum < -180 || lngNum > 180) {
            message.error("Longitude must be between -180 and 180!");
            return;
        }

        // Call the onOk callback with the validated values
        onOk(latNum, lngNum);
    };

    const handleCancel = () => {
        // Reset fields
        setLatitude("");
        setLongitude("");
        onCancel();
    };

    return (
        <Modal
            title="Verify Address Book Location"
            visible={visible}
            onOk={handleOk}
            onCancel={handleCancel}
            centered={true}
            okText="Verify"
            cancelText="Cancel"
            className="verify-address-book-modal"
        >
            <div className="verify-address-book-content">
                {addressRecord && (
                    <div className="address-info">
                        <Row gutter={[16, 16]}>
                            <Col span={24}>
                                <strong>Address Name:</strong> {addressRecord.name}
                            </Col>
                            <Col span={24}>
                                <strong>City:</strong> {addressRecord.city}
                            </Col>
                            <Col span={24}>
                                <strong>Address:</strong> {addressRecord.address}
                            </Col>
                        </Row>
                    </div>
                )}
                
                <div className="coordinates-section">
                    <Row gutter={[16, 16]}>
                        <Col span={24}>
                            <label className="required-label">
                                Latitude <span className="required-asterisk">*</span>
                            </label>
                            <Input
                                placeholder="Enter Latitude (e.g., 12.9716)"
                                value={latitude}
                                onChange={(e) => setLatitude(e.target.value)}
                                type="text"
                            />
                        </Col>
                        <Col span={24}>
                            <label className="required-label">
                                Longitude <span className="required-asterisk">*</span>
                            </label>
                            <Input
                                placeholder="Enter Longitude (e.g., 77.5946)"
                                value={longitude}
                                onChange={(e) => setLongitude(e.target.value)}
                                type="text"
                            />
                        </Col>
                    </Row>
                </div>

                <div className="help-text">
                    <small>
                        Note: Both Latitude and Longitude are mandatory fields. 
                        You can get coordinates from Google Maps by right-clicking on a location.
                    </small>
                </div>
            </div>
        </Modal>
    );
};

